export default __webpack_public_path__ + "static/media/ema watson.d1ca9a53.jpg";